import { bootstrap } from '@myatt/omhub-ui';
bootstrap().catch(() => {
    console.error('App bootstrap failed for outage lander... ');
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx